import { mapUserFromDTO } from '@entities/user/api/mappers'
import type { Relation, RelationDTO } from '../model/types'
import type { CreateRelationArgs, CreateRelationArgsDTO, EditRelationArgs, EditRelationArgsDTO } from './types'

export const mapRelationFromDTO = ({
    id,
    seller,
    customer,
    budget,
    status,
    like_seller,
    dislike_seller,
    like_customer,
    dislike_customer,
    created_at,
    updated_at,
    channel,
    token
}: RelationDTO): Relation => ({
    id,
    seller: mapUserFromDTO(seller),
    customer: mapUserFromDTO(customer),
    budget,
    status,
    likeSeller: like_seller,
    dislikeSeller: dislike_seller,
    likeCustomer: like_customer,
    dislikeCustomer: dislike_customer,
    createdAt: new Date(created_at),
    updatedAt: new Date(updated_at),
    channel,
    token
})

export const mapCreateRelationArgsToDTO = ({ tokenUuid }: CreateRelationArgs): CreateRelationArgsDTO => ({
    token_uuid: tokenUuid
})

export const mapEditRelationArgsToDTO = ({
    status,
    dislikeCustomer,
    dislikeSeller,
    likeCustomer,
    likeSeller
}: Omit<EditRelationArgs, 'id'>): EditRelationArgsDTO => ({
    status,
    like_customer: likeCustomer,
    like_seller: likeSeller,
    dislike_customer: dislikeCustomer,
    dislike_seller: dislikeSeller
})
